import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslatePipe} from './translate.pipe';
import { TranslateWithArgsPipe } from './translate-with-args.pipe';
import { LibAddressPipe } from '../shared/pipes/lib-address.pipe';
import { TruncatePipe } from '../shared/pipes/truncate.pipe';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [TranslatePipe, TranslateWithArgsPipe, LibAddressPipe, TruncatePipe],
  exports: [TranslatePipe, TranslateWithArgsPipe, LibAddressPipe, TruncatePipe]
})
export class ApplicationPipesModule {
}
